<template>

  <v-app light>

    <v-toolbar app clipped-left fixed prominent dark color="teal darken-3">

      <v-btn icon @click.native="cancel">
        <v-icon>arrow_back</v-icon>
      </v-btn>

      <v-toolbar-title v-text="'Sobre'"></v-toolbar-title>

      <v-spacer></v-spacer>

    </v-toolbar>

    <v-content>

      <v-container fluid grid-list-lg>
        <v-layout row wrap>

          <v-flex xs12>
            <p class="text-xs-center my-2 hidden-md-and-up">
              <img src="/img/stamp_partners.png" style="width: 300px;" />
            </p>
            <p class="text-xs-center my-2 hidden-sm-and-down">
              <img src="/img/stamp_partners.png" />
            </p>
          </v-flex>

          <v-flex xs12 sm12 md10 offset-md1 lg8 offset-lg2 xl6 offset-xl3 class="my-3">
            <v-card class="px-3 py-2">
              <v-card-text>
                <p>
                  O aplicativo <strong>CustoBov</strong> foi desenvolvido pela <a href="https://www.facom.ufms.br/engenharia-de-software/fabrica-de-software/" style="color:#00695c;" target="_blank">Fábrica de Software - UFMS</a> em parceria com a
                  <a href="http://embrapa.br/gado-de-corte" style="color:#00695c;" target="_blank">Embrapa Gado de Corte</a>,
                  em Campo Grande - MS.
                </p>
                <p>
                  Para gerenciar seus dados armazenados nos servidores da Embrapa, acesse a
                  <a :href="settings.api.slice(0, -3)" style="color:#00695c;" target="_blank">aplicação Web</a> da plataforma <strong>CustoBov</strong>.
                  Estes dados são mantidos conforme estabelecido em nossa
                  <a href="../privacy-policy.html" style="color:#00695c;" target="_blank">política de privacidade</a>.
                </p>
                <p>
                  Encontrou algum problema? Por favor, nos avise informando o número da versão abaixo, a
                  mensagem de erro e o modelo do seu <em>smartphone</em> pelo nosso
                  e-mail de suporte:.
                </p>
                <p class="text-xs-center">
                  <a :href="'mailto: ' + settings.support + '?subject=Problemas%20na%20vers%C3%A3o%20' + version + '%20do%20CustoBov'" style="color:#00695c;" target="_blank">{{ settings.support }}</a>
                </p>
              </v-card-text>
            </v-card>
          </v-flex>

          <v-flex xs12 sm12 md10 offset-md1 lg8 offset-lg2 xl6 offset-xl3 class="my-3">
            <p class="body-2 text-xs-center">Versão {{ version }}</p>
          </v-flex>

        </v-layout>
      </v-container>

    </v-content>

  </v-app>

</template>

<script>

var settings = require('../settings/' + process.env.NODE_ENV + '.json')
var pkg = require('../../package.json')

export default {
  
  data () {
    return {
      version: pkg.version,
      settings: settings
    }
  },
  methods: {
    cancel () {
      this.$router.push({ path: '/home' })
    }
  }
}
</script>